import React from 'react';
import MultiSelectFilter from './MultiSelectFilter';

/**
 * «Conducta presente» / «Conducta no presente»: lo que el agente hizo o no hizo
 * según la boleta V2 (12-oct-2026). UNA sola vez para las dos pantallas que lo
 * ofrecen — Llamadas del supervisor (`AnalyticsFilterBar`, grupo «Filtros de Conducta») y
 * Mis llamadas del Agente (`AgentDashboard`, 14-oct-2026). Dos copias del mismo
 * par de filtros terminarían diciendo cosas distintas.
 *
 * Las MISMAS quince opciones en los dos, con sentido contrario. Por eso cada
 * lista dice arriba qué significa marcar, el botón lleva ✓ / ✗, y lo marcado en
 * uno se deshabilita en el otro: pedir la misma conducta presente Y ausente da
 * siempre cero llamadas.
 *
 * Trabaja con ETIQUETAS (lo que muestra el selector); `clavesDeConducta`
 * las convierte en las claves de la rúbrica que espera el API.
 *
 * @param {{key: string, label: string}[]} props.catalogo  `conductas_v2` de `/api/calls/filters`.
 * @param {boolean} [props.primeraPersona=false]  «SÍ hice» en vez de «el agente
 *   SÍ hizo»: en Mis llamadas quien lee es el agente.
 */
export default function FiltrosDeConducta({
  catalogo = [],
  presentes,
  ausentes,
  onPresentes,
  onAusentes,
  primeraPersona = false,
}) {
  const opciones = catalogo.map((c) => c.label);
  const hizo = primeraPersona ? 'SÍ hice' : 'el agente SÍ hizo';
  const noHizo = primeraPersona ? 'NO hice' : 'el agente NO hizo';
  return (
    <>
      <MultiSelectFilter
        label="Conducta presente"
        options={opciones}
        value={presentes}
        onChange={onPresentes}
        encabezado={`✓ Llamadas donde ${hizo}…`}
        prefijo="✓ "
        deshabilitadas={Object.fromEntries(ausentes.map((e) => [e, 'Ya está en «Conducta no presente»']))}
        resumen={presentes.length > 1 ? `✓ Presente: ${presentes.length}` : undefined}
        titulo={presentes.length
          ? `Llamadas donde ${hizo} todas: ${presentes.join(', ')}`
          : `Llamadas donde ${hizo} la conducta (boleta V2). Varias: todas a la vez.`}
      />
      <MultiSelectFilter
        label="Conducta no presente"
        options={opciones}
        value={ausentes}
        onChange={onAusentes}
        encabezado={`✗ Llamadas donde ${noHizo}…`}
        prefijo="✗ "
        deshabilitadas={Object.fromEntries(presentes.map((e) => [e, 'Ya está en «Conducta presente»']))}
        resumen={ausentes.length > 1 ? `✗ No presente: ${ausentes.length}` : undefined}
        titulo={ausentes.length
          ? `Llamadas donde ${noHizo} ninguna de: ${ausentes.join(', ')}`
          : `Llamadas donde ${noHizo} la conducta (boleta V2). Varias: todas a la vez.`}
      />
    </>
  );
}

/** De etiquetas a claves de la rúbrica. Una etiqueta guardada que ya no está
 *  en el catálogo se cae aquí en vez de mandar al API algo que no existe. */
export function clavesDeConducta(catalogo, etiquetas) {
  const clave = new Map((catalogo || []).map((c) => [c.label, c.key]));
  return (etiquetas || []).map((e) => clave.get(e)).filter(Boolean);
}
